import { useState } from 'react'
import { Box, Flex, VStack } from '~/design_system'
import { ThreadContent } from './components/ThreadContent'
import { ThreadFooter } from './components/ThreadFooter'
import { ThreadHeader } from './components/ThreadHeader'
import { ThreadHistory } from './components/ThreadHistory'

type ThreadProps = {
  onClose?: () => void
  isExpanded?: boolean
  onToggleExpand?: () => void
}

export const Thread = ({ onClose, isExpanded, onToggleExpand }: ThreadProps) => {
  const [showHistory, setShowHistory] = useState(false)

  const handleToggleExpand = () => {
    setShowHistory(false)
    onToggleExpand?.()
  }

  const closeHistory = () => setShowHistory(false)

  if (!isExpanded && showHistory) {
    return <ThreadHistory variant="page" onBack={closeHistory} onClose={onClose} onOpenConversation={closeHistory} />
  }

  return (
    <Flex height="100%" w="100%" bg="white" direction={isExpanded ? 'row' : 'column'}>
      {isExpanded && (
        <Box w="280px" minW="280px" h="100%" borderRight="1px solid" borderColor="gray.200">
          <ThreadHistory variant="sidebar" />
        </Box>
      )}
      <VStack spacing={0} align="stretch" h="100%" flex="1" minW={0}>
        <ThreadHeader
          onClose={onClose}
          isExpanded={isExpanded}
          onToggleExpand={handleToggleExpand}
          onShowHistory={isExpanded ? undefined : () => setShowHistory(true)}
        />
        <Box flex="1" minH="0">
          <ThreadContent />
        </Box>
        <ThreadFooter />
      </VStack>
    </Flex>
  )
}
